"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _dist = require("package_ui_ihm/dist");
var _Divider = _interopRequireDefault(require("@mui/material/Divider"));
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regeneratorValues(e) { if (null != e) { var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0; if (t) return t.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } }; } throw new TypeError(_typeof(e) + " is not iterable"); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /**
* Nom : treatmentParamList.js
* Description : Ce fichier contient la définition de la page treatmentParamList 
*               Cette page liste les traitements disponibles sur un produit client
* Date de création : 30 septembre 2025
*/ /* CSS et assets */ // None
/* Bibliothèques et composants */ /* Hook */ /**
* TreatmentParamList : affiche la page qui liste les traitements disponibles sur un produit client
*                      filtrage de la liste possible selon la catégorie, la variété et le type de traitement
*                      un lien permet d'afficher une page avec un formulaire pour créer un nouveau traitement
*                      un click sur le traitement permet d'afficher sa page avec ses informations détaillées
*                      un lien permet de revenir sur la page qui contient les information détaillées du produit client
*
* Type : page 
*
* Parametres : 
*  None
*/
function TreatmentParamList() {
  //Define useParam
  var _useParams = (0, _reactRouterDom.useParams)(),
    equipmentId = _useParams.equipmentId;

  // Define useState hooks
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    selectedCat = _useState2[0],
    setSelectedCat = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedVar = _useState4[0],
    setSelectedVar = _useState4[1];
  var _useState5 = (0, _react.useState)(0),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedTargetType = _useState6[0],
    setSelectedTargetType = _useState6[1];
  var _useState7 = (0, _react.useState)(0),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedTreatmentType = _useState8[0],
    setSelectedTreatmentType = _useState8[1];
  var _useState9 = (0, _react.useState)(0),
    _useState0 = _slicedToArray(_useState9, 2),
    prevCat = _useState0[0],
    setPrevCat = _useState0[1];
  var _useState1 = (0, _react.useState)([]),
    _useState10 = _slicedToArray(_useState1, 2),
    categories = _useState10[0],
    setCategories = _useState10[1];
  var _useState11 = (0, _react.useState)([]),
    _useState12 = _slicedToArray(_useState11, 2),
    varieties = _useState12[0],
    setVarieties = _useState12[1];
  var _useState13 = (0, _react.useState)([]),
    _useState14 = _slicedToArray(_useState13, 2),
    targetTypeList = _useState14[0],
    setTargetTypeList = _useState14[1];
  var _useState15 = (0, _react.useState)([]),
    _useState16 = _slicedToArray(_useState15, 2),
    treatmentTypes = _useState16[0],
    setTreatmentTypes = _useState16[1];
  var _useState17 = (0, _react.useState)(null),
    _useState18 = _slicedToArray(_useState17, 2),
    equipment = _useState18[0],
    setEquipment = _useState18[1];
  var _useState19 = (0, _react.useState)([]),
    _useState20 = _slicedToArray(_useState19, 2),
    treatmentParams = _useState20[0],
    setTreatmentParams = _useState20[1];
  var _useState21 = (0, _react.useState)(varieties),
    _useState22 = _slicedToArray(_useState21, 2),
    filteredVarieties = _useState22[0],
    setFilteredVarieties = _useState22[1];
  var _useState23 = (0, _react.useState)([]),
    _useState24 = _slicedToArray(_useState23, 2),
    filteredTreatmentParams = _useState24[0],
    setFilteredTreatmentParams = _useState24[1];
  var _useState25 = (0, _react.useState)(null),
    _useState26 = _slicedToArray(_useState25, 2),
    statusCategory = _useState26[0],
    setStatusCategory = _useState26[1];
  var _useState27 = (0, _react.useState)(null),
    _useState28 = _slicedToArray(_useState27, 2),
    statusVariety = _useState28[0],
    setStatusVariety = _useState28[1];
  var _useState29 = (0, _react.useState)(null),
    _useState30 = _slicedToArray(_useState29, 2),
    statusTreatmentType = _useState30[0],
    setStatusTreatmentType = _useState30[1];
  var _useState31 = (0, _react.useState)(null),
    _useState32 = _slicedToArray(_useState31, 2),
    statusTreatmentParams = _useState32[0],
    setStatusTreatmentParams = _useState32[1];
  var _useState33 = (0, _react.useState)(false),
    _useState34 = _slicedToArray(_useState33, 2),
    isDataLoading = _useState34[0],
    setDataLoading = _useState34[1];

  // Define useContext hooks
  var _useAuth = (0, _dist.useAuth)(),
    authStatus = _useAuth.authStatus,
    authToken = _useAuth.authToken,
    currentUser = _useAuth.currentUser;
  var _useApi = (0, _dist.useApi)(),
    path = _useApi.path,
    applicationName = _useApi.applicationName;
  var _useData = (0, _dist.useData)(),
    targetTypes = _useData.targetTypes;

  // Define useScreenWidth hooks
  var screenWidth = (0, _dist.useScreenWidth)();

  // Define functions
  function updateFilteredTreatmentParams() {
    // Filter category
    if (Number(selectedCat) > 0 && Number(selectedVar) === 0 && Number(selectedTargetType) === 0 && Number(selectedTreatmentType) === 0) {
      setFilteredTreatmentParams(treatmentParams.filter(function (treatmentParam) {
        return treatmentParam.category['id'] === Number(selectedCat);
      }));
    }
    // Filter variety
    else if (Number(selectedCat) === 0 && Number(selectedVar) > 0 && Number(selectedTargetType) === 0 && Number(selectedTreatmentType) === 0) {
      setFilteredTreatmentParams(treatmentParams.filter(function (treatmentParam) {
        return treatmentParam.variety['id'] === Number(selectedVar);
      }));
    }
    // Filter target type
    else if (Number(selectedCat) === 0 && Number(selectedVar) === 0 && Number(selectedTargetType) > 0 && Number(selectedTreatmentType) === 0) {
      setFilteredTreatmentParams(treatmentParams.filter(function (treatmentParam) {
        return treatmentParam.target_type['id'] === Number(selectedTargetType);
      }));
    }
    // Filter treatment type
    else if (Number(selectedCat) === 0 && Number(selectedVar) === 0 && Number(selectedTargetType) === 0 && Number(selectedTreatmentType) > 0) {
      setFilteredTreatmentParams(treatmentParams.filter(function (treatmentParam) {
        return treatmentParam.treatment_type['id'] === Number(selectedTreatmentType);
      }));
    }
    // Filter category and variety
    else if (Number(selectedCat) > 0 && Number(selectedVar) > 0 && Number(selectedTargetType) === 0 && Number(selectedTreatmentType) === 0) {
      setFilteredTreatmentParams(treatmentParams.filter(function (treatmentParam) {
        return treatmentParam.category['id'] === Number(selectedCat) && treatmentParam.variety['id'] === Number(selectedVar);
      }));
    }
    // Filter category and target type
    else if (Number(selectedCat) > 0 && Number(selectedVar) === 0 && Number(selectedTargetType) > 0 && Number(selectedTreatmentType) === 0) {
      setFilteredTreatmentParams(treatmentParams.filter(function (treatmentParam) {
        return treatmentParam.category['id'] === Number(selectedCat) && treatmentParam.target_type['id'] === Number(selectedTargetType);
      }));
    }
    // Filter category and treatment type
    else if (Number(selectedCat) > 0 && Number(selectedVar) === 0 && Number(selectedTargetType) === 0 && Number(selectedTreatmentType) > 0) {
      setFilteredTreatmentParams(treatmentParams.filter(function (treatmentParam) {
        return treatmentParam.category['id'] === Number(selectedCat) && treatmentParam.treatment_type['id'] === Number(selectedTreatmentType);
      }));
    }
    // Filter variety and target type
    else if (Number(selectedCat) === 0 && Number(selectedVar) > 0 && Number(selectedTargetType) > 0 && Number(selectedTreatmentType) === 0) {
      setFilteredTreatmentParams(treatmentParams.filter(function (treatmentParam) {
        return treatmentParam.variety['id'] === Number(selectedVar) && treatmentParam.target_type['id'] === Number(selectedTargetType);
      }));
    }
    // Filter variety and treatment type
    else if (Number(selectedCat) === 0 && Number(selectedVar) > 0 && Number(selectedTargetType) === 0 && Number(selectedTreatmentType) > 0) {
      setFilteredTreatmentParams(treatmentParams.filter(function (treatmentParam) {
        return treatmentParam.variety['id'] === Number(selectedVar) && treatmentParam.treatment_type['id'] === Number(selectedTreatmentType);
      }));
    }
    // Filter target type and treatment type
    else if (Number(selectedCat) === 0 && Number(selectedVar) === 0 && Number(selectedTargetType) > 0 && Number(selectedTreatmentType) > 0) {
      setFilteredTreatmentParams(treatmentParams.filter(function (treatmentParam) {
        return treatmentParam.target_type['id'] === Number(selectedTargetType) && treatmentParam.treatment_type['id'] === Number(selectedTreatmentType);
      }));
    }
    // Filter category and variety and target type
    else if (Number(selectedCat) > 0 && Number(selectedVar) > 0 && Number(selectedTargetType) > 0 && Number(selectedTreatmentType) === 0) {
      setFilteredTreatmentParams(treatmentParams.filter(function (treatmentParam) {
        return treatmentParam.category['id'] === Number(selectedCat) && treatmentParam.variety['id'] === Number(selectedVar) && treatmentParam.target_type['id'] === Number(selectedTargetType);
      }));
    }
    // Filter category and variety and treatment type
    else if (Number(selectedCat) > 0 && Number(selectedVar) > 0 && Number(selectedTargetType) === 0 && Number(selectedTreatmentType) > 0) {
      setFilteredTreatmentParams(treatmentParams.filter(function (treatmentParam) {
        return treatmentParam.category['id'] === Number(selectedCat) && treatmentParam.variety['id'] === Number(selectedVar) && treatmentParam.treatment_type['id'] === Number(selectedTreatmentType);
      }));
    }
    // Filter category and target type and treatment type
    else if (Number(selectedCat) > 0 && Number(selectedVar) === 0 && Number(selectedTargetType) > 0 && Number(selectedTreatmentType) > 0) {
      setFilteredTreatmentParams(treatmentParams.filter(function (treatmentParam) {
        return treatmentParam.category['id'] === Number(selectedCat) && treatmentParam.target_type['id'] === Number(selectedTargetType) && treatmentParam.treatment_type['id'] === Number(selectedTreatmentType);
      }));
    }
    // Filter variety and target type and treatment type
    else if (Number(selectedCat) === 0 && Number(selectedVar) > 0 && Number(selectedTargetType) > 0 && Number(selectedTreatmentType) > 0) {
      setFilteredTreatmentParams(treatmentParams.filter(function (treatmentParam) {
        return treatmentParam.variety['id'] === Number(selectedVar) && treatmentParam.target_type['id'] === Number(selectedTargetType) && treatmentParam.treatment_type['id'] === Number(selectedTreatmentType);
      }));
    }
    // Filter category and variety and target type and treatment type
    else if (Number(selectedCat) > 0 && Number(selectedVar) > 0 && Number(selectedTargetType) > 0 && Number(selectedTreatmentType) > 0) {
      setFilteredTreatmentParams(treatmentParams.filter(function (treatmentParam) {
        return treatmentParam.category['id'] === Number(selectedCat) && treatmentParam.variety['id'] === Number(selectedVar) && treatmentParam.target_type['id'] === Number(selectedTargetType) && treatmentParam.treatment_type['id'] === Number(selectedTreatmentType);
      }));
    }
    // No filter
    else {
      setFilteredTreatmentParams(treatmentParams);
    }
  }
  function updateFilteredVarieties() {
    // Check category change to reinit variety
    if (selectedCat !== prevCat) {
      setSelectedVar(0);
      setPrevCat(selectedCat);
    }
    // Filtering of varieties
    if (selectedCat > 0) {
      setFilteredVarieties(varieties.filter(function (variety) {
        return variety.category_id === Number(selectedCat);
      }));
    } else {
      setFilteredVarieties(varieties);
    }
  }
  function retrieveData() {
    return _retrieveData.apply(this, arguments);
  }
  function _retrieveData() {
    _retrieveData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var token, headers, _yield$Promise$all, _yield$Promise$all2, resCategory, resVariety, resTreatmentType, _yield$Promise$all3, _yield$Promise$all4, dataCategory, dataVariety, dataTreatmentType, resEquipment, dataEquipment, resTreatmentParam, dataTreatmentParam, treatment_param_list, category_list, variety_list, target_type_list, treatment_type_list, _iterator, _step, _loop, _t;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            // Token
            token = "Bearer " + authToken; // Headers
            headers = {
              accept: 'application/json',
              Authorization: token
            }; // Category, variety, target_type and treatment_type (in case of BOXIBRAIN application)
            if (!(applicationName === 'BOXIBRAIN')) {
              _context2.n = 3;
              break;
            }
            _context2.n = 1;
            return Promise.all([
            // Categories
            fetch(path + "/api/bo-cary/", {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: headers
            }),
            // Varieties
            fetch(path + "/api/bo-vaty/", {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: headers
            }),
            // Treatment types
            fetch(path + "/api/bo-trty/", {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: headers
            })]);
          case 1:
            _yield$Promise$all = _context2.v;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 3);
            resCategory = _yield$Promise$all2[0];
            resVariety = _yield$Promise$all2[1];
            resTreatmentType = _yield$Promise$all2[2];
            _context2.n = 2;
            return Promise.all([resCategory.json(), resVariety.json(), resTreatmentType.json()]);
          case 2:
            _yield$Promise$all3 = _context2.v;
            _yield$Promise$all4 = _slicedToArray(_yield$Promise$all3, 3);
            dataCategory = _yield$Promise$all4[0];
            dataVariety = _yield$Promise$all4[1];
            dataTreatmentType = _yield$Promise$all4[2];
            // Set variables 
            setStatusCategory(resCategory.ok);
            setCategories(dataCategory["results"].sort(function (a, b) {
              return a.name > b.name ? 1 : -1;
            }));
            setStatusVariety(resVariety.ok);
            setVarieties(dataVariety["results"].sort(function (a, b) {
              return a.name > b.name ? 1 : -1;
            }));
            setTargetTypeList(targetTypes);
            setStatusTreatmentType(resTreatmentType.ok);
            setTreatmentTypes(dataTreatmentType["results"].sort(function (a, b) {
              return a.name > b.name ? 1 : -1;
            }));
          case 3:
            _context2.n = 4;
            return fetch(path + "/api/eq-eqnt/" + equipmentId + "/", {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: headers
            });
          case 4:
            resEquipment = _context2.v;
            _context2.n = 5;
            return resEquipment.json();
          case 5:
            dataEquipment = _context2.v;
            setEquipment(dataEquipment);
            // TreatmentParams
            _context2.n = 6;
            return fetch(path + "/api/eq-trpa/?equipment_id=" + equipmentId, {
              method: 'GET',
              credentials: 'include',
              mode: 'cors',
              headers: headers
            });
          case 6:
            resTreatmentParam = _context2.v;
            _context2.n = 7;
            return resTreatmentParam.json();
          case 7:
            dataTreatmentParam = _context2.v;
            setStatusTreatmentParams(resTreatmentParam.ok);
            treatment_param_list = dataTreatmentParam["results"];
            setTreatmentParams(treatment_param_list);
            // Category, variety, target_type and treatment_type (in case of BOXILUMIX application)
            if (!(applicationName === 'BOXILUMIX')) {
              _context2.n = 15;
              break;
            }
            category_list = [];
            variety_list = [];
            target_type_list = [];
            treatment_type_list = [];
            _iterator = _createForOfIteratorHelper(treatment_param_list);
            _context2.p = 8;
            _loop = /*#__PURE__*/_regenerator().m(function _loop() {
              var treatment_param;
              return _regenerator().w(function (_context) {
                while (1) switch (_context.n) {
                  case 0:
                    treatment_param = _step.value;
                    if (category_list.find(function (item) {
                      return item['name'] === treatment_param['category']['name'];
                    }) === undefined) {
                      category_list.push(treatment_param['category']);
                    }
                    if (variety_list.find(function (item) {
                      return item['name'] === treatment_param['variety']['name'];
                    }) === undefined) {
                      variety_list.push(treatment_param['variety']);
                    }
                    if (target_type_list.find(function (item) {
                      return item['name'] === treatment_param['target_type']['name'];
                    }) === undefined) {
                      target_type_list.push(treatment_param['target_type']);
                    }
                    if (treatment_type_list.find(function (item) {
                      return item['name'] === treatment_param['treatment_type']['name'];
                    }) === undefined) {
                      treatment_type_list.push(treatment_param['treatment_type']);
                    }
                  case 1:
                    return _context.a(2);
                }
              }, _loop);
            });
            _iterator.s();
          case 9:
            if ((_step = _iterator.n()).done) {
              _context2.n = 11;
              break;
            }
            return _context2.d(_regeneratorValues(_loop()), 10);
          case 10:
            _context2.n = 9;
            break;
          case 11:
            _context2.n = 13;
            break;
          case 12:
            _context2.p = 12;
            _t = _context2.v;
            _iterator.e(_t);
          case 13:
            _context2.p = 13;
            _iterator.f();
            return _context2.f(13);
          case 14:
            setCategories(category_list.sort(function (a, b) {
              return a.name > b.name ? 1 : -1;
            }));
            setVarieties(variety_list.sort(function (a, b) {
              return a.name > b.name ? 1 : -1;
            }));
            setTargetTypeList(target_type_list.sort(function (a, b) {
              return a.name > b.name ? 1 : -1;
            }));
            setTreatmentTypes(treatment_type_list.sort(function (a, b) {
              return a.name > b.name ? 1 : -1;
            }));
          case 15:
            // Dataloading
            setDataLoading(false);
          case 16:
            return _context2.a(2);
        }
      }, _callee, null, [[8, 12, 13, 14]]);
    }));
    return _retrieveData.apply(this, arguments);
  }
  var filterReset = function filterReset(event) {
    event.preventDefault();
    setFilteredTreatmentParams(treatmentParams);
    setSelectedCat(0);
    setSelectedVar(0);
    setSelectedTargetType(0);
    setSelectedTreatmentType(0);
  };

  // Define useEffect hooks
  (0, _react.useEffect)(function () {
    if (authStatus === 200) {
      setDataLoading(true);
      retrieveData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  (0, _react.useEffect)(function () {
    updateFilteredVarieties();
    updateFilteredTreatmentParams();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [treatmentParams, selectedCat, selectedVar, selectedTargetType, selectedTreatmentType]);

  // Render component
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    children: [applicationName === "BOXILUMIX" ? currentUser && (currentUser["role_name"] === "AT_ADMIN" || currentUser["role_name"] === "AT_SUPPORT") ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.CompanyBar, {
      name_app: "BOXILUMIX"
    }) : null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.CompanyBar, {
      name_app: "BOXIBRAIN"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.TabC, {
      tabNumber: 1
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: screenWidth > 650 ? 'App' : 'App-ss',
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.Container, {
        children: isDataLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          children: "Chargement des donn\xE9es"
        }) : statusTreatmentParams === true && (applicationName === 'BOXILUMIX' || applicationName === 'BOXIBRAIN' && statusCategory === true && statusVariety === true && statusTreatmentType === true) ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("h1", {
            children: ["Traitements disponibles sur le ", equipment['product']['name'], " ", equipment["serial_number"], " - ", equipment['identifier']]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "flex-row justify-start margin-left margin-bottom margin-top",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: "link-border",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.BackPage, {
                path: '/equipments/' + equipmentId,
                children: "Retour au d\xE9tail du produit client"
              })
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: screenWidth > 650 ? 'grid-1-3' : null,
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: "flex-rows",
              children: [applicationName === "BOXIBRAIN" ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.AddItem, {
                path: '/treatment-params/new/' + equipmentId,
                children: "Ajouter un traitement"
              }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                children: "Filtres"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.ListFilter, {
                labelText: "Cat\xE9gorie",
                choices: categories.sort(function (a, b) {
                  return a.name > b.name ? 1 : -1;
                }),
                choiceParam: 'name',
                selectedItem: selectedCat,
                setSelectedItem: setSelectedCat,
                subfilter: false
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.ListFilter, {
                labelText: "Vari\xE9t\xE9",
                choices: filteredVarieties.sort(function (a, b) {
                  return a.name > b.name ? 1 : -1;
                }),
                choiceParam: 'name',
                selectedItem: selectedVar,
                setSelectedItem: setSelectedVar,
                subfilter: true
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.ListFilter, {
                labelText: "Type de cible",
                choices: targetTypeList.sort(function (a, b) {
                  return a.name > b.name ? 1 : -1;
                }),
                choiceParam: 'name',
                selectedItem: selectedTargetType,
                setSelectedItem: setSelectedTargetType,
                subfilter: false
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.ListFilter, {
                labelText: "Type de traitement",
                choices: treatmentTypes.sort(function (a, b) {
                  return a.name > b.name ? 1 : -1;
                }),
                choiceParam: 'name',
                selectedItem: selectedTreatmentType,
                setSelectedItem: setSelectedTreatmentType,
                subfilter: false
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
                  onClick: filterReset,
                  className: "button-secondary clickable",
                  children: "Sans filtres"
                })
              })]
            }), screenWidth > 650 ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Divider["default"], {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: "scroll-list-rd",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("h2", {
                className: "subtitle",
                children: ["Nombre de traitements : ", filteredTreatmentParams.length]
              }), filteredTreatmentParams && filteredTreatmentParams.length !== 0 ? filteredTreatmentParams.sort(function (a, b) {
                return a.name > b.name ? 1 : -1;
              }).map(function (treatment_param) {
                return /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.ItemLink, {
                  id: treatment_param['id'],
                  path: "/treatment-params/detail/" + treatment_param['equipment_id'] + '/',
                  children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                    className: "grid-1-1",
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h3", {
                      className: "item-text",
                      children: treatment_param['name']
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                      className: "flex-row justify-end",
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                        className: "item-text",
                        children: treatment_param['category']['name']
                      })
                    })]
                  })
                }, treatment_param['id']);
              }) : applicationName === "BOXIBRAIN" ? /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                children: "Aucun traitement disponible actuellement. Veuillez en cr\xE9er un ! "
              }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
                children: "Aucun traitement disponible actuellement."
              })]
            })]
          })]
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)("h1", {
          children: "Connexion failed"
        })
      })
    })]
  });
}
var _default = exports["default"] = TreatmentParamList;